import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { TabType } from 'react-scale/components/scalers/tasks/ThreadedInteraction/coding/types';
import _ from 'lodash';
import { Optional } from 'utility-types';

export type CodeExecutionState = {
  outputTabOpen: boolean;
  tab: TabType;
};

type CodeExecutionStateStore = {
  codeExecutionState: Record<string, CodeExecutionState>;
  setCodeExecutionState: (storeKey: string, newState: Optional<CodeExecutionState>) => void;
  getCodeExecutionState: (storeKey: string) => CodeExecutionState;
};

/**
 * Store for persisting code and language state for scratchpads
 */
export const useCodeExecutionStateStore = create<CodeExecutionStateStore>()(
  devtools((set, get) => ({
    codeExecutionState: {},
    setCodeExecutionState: (storeKey: string, newState: Optional<CodeExecutionState>) => {
      set(state => ({
        codeExecutionState: {
          ...state.codeExecutionState,
          [storeKey]: _.merge(state.codeExecutionState[storeKey], newState),
        },
      }));
    },
    getCodeExecutionState: (storeKey: string) => {
      const cachedState = get().codeExecutionState[storeKey];
      if (!cachedState || Object.keys(cachedState).length === 0) {
        return { outputTabOpen: false, tab: TabType.STDOUT };
      }

      return cachedState;
    },
  })),
);
